// UI texts: privacy page (krug 3, U6). Plain words about what the game actually keeps.
export default {
  docTitle: 'Privacy · AFTER DAY',
  title: 'Privacy',
  updated: 'Last updated: September 2026',
  intro: 'AFTER DAY is a browser game. This page says what we keep about you, why, and how to get rid of it.',
  back: 'Back',
  sections: {
    account: {
      title: 'Your account',
      body: 'A guest account is a random id tied to this browser. If you link an email, we keep the address to send you sign-in links. If you sign in with Google, we keep your Google account id and email. Nothing else comes from those services.',
    },
    game: {
      title: 'Your game',
      body: 'Your survivor, gear, expeditions and reports, friends, crew chat messages and settings are stored on our server so the shared world works. Other players see your survivor name, level, look and title in encounters, the feed and share cards.',
    },
    tech: {
      title: 'Technical data',
      body: 'We store the IP address of your last visit and of each sign-in session. It is used to stop cheating (two accounts on one network never pass loot to each other) and to limit abuse. For rewarded ads we only keep a scrambled form of the IP. We log game events (sessions, runs, shares, ads watched) to measure how the game is doing. There are no third-party trackers.',
    },
    cookies: {
      title: 'Cookies and storage',
      body: 'One cookie keeps you signed in (ld_session, up to 180 days). During a Google sign-in a second cookie lives for 10 minutes. The browser also remembers an invite code and a few screen settings. No advertising cookies.',
    },
    email: {
      title: 'Email',
      body: 'We only email sign-in links and, if you allow it in Settings, a short note when your survivor is back or your tracks were beaten, and, only if you turn it on, when your energy is full. If you leave your email for news on the start page, we keep it for that and never sell or share it.',
    },
    notifications: {
      title: 'Notifications',
      body: 'If you turn on push notifications, your browser gives us an address to send them to. Turning them off in Settings or in the browser stops them.',
    },
    // 11. 10. 2026 (owner, BACKLOG #33): the crew chat's rules, in the terms.
    crewChat: {
      title: 'Crew chat rules',
      body: 'The crew chat is only for the members of your crew. Be decent: no insults, hate, threats, spam or anything illegal; bad words are hidden automatically. Any member can report a message or block a player. Reported messages are read by the game’s admin, who can delete them, close the chat for a player for a time or ban an account. Messages are kept for 30 days.',
    },
    feedback: {
      title: 'Feedback',
      body: 'What you send with the Feedback button (text, and a screenshot if you add one) is stored so we can read it and fix things.',
    },
    delete: {
      title: 'Deleting your data',
      body: 'Ask us and we delete your account and everything linked to it. Signing out of a guest account leaves the survivor behind on the server, but nobody can reach it without the browser it lived in.',
    },
    contact: {
      title: 'Contact',
      emailPrefix: 'Write to',
      noEmail: 'Use the Feedback button in the game menu.',
    },
  },
} as const;
